/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface ForfaitAuditeurSearch
 */
export interface ForfaitAuditeurSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof ForfaitAuditeurSearch
     */
    anneeAcademique?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof ForfaitAuditeurSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ForfaitAuditeurSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ForfaitAuditeurSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ForfaitAuditeurSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ForfaitAuditeurSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ForfaitAuditeurSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ForfaitAuditeurSearch interface.
 */
export function instanceOfForfaitAuditeurSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ForfaitAuditeurSearchFromJSON(json: any): ForfaitAuditeurSearch {
    return ForfaitAuditeurSearchFromJSONTyped(json, false);
}

export function ForfaitAuditeurSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ForfaitAuditeurSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'anneeAcademique': !exists(json, 'anneeAcademique') ? undefined : TextSearchFromJSON(json['anneeAcademique']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ForfaitAuditeurSearchToJSON(value?: ForfaitAuditeurSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'anneeAcademique': TextSearchToJSON(value.anneeAcademique),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

